// src/utils/fakeData/menuList.js
// Imported in component/common/headers/headerOne.jsx

export const menuList = [
  {
    id: 1,
    path: "#",
    label: "服務",
    dropDown: [
      {
        id: 1,
        path: "/contract",
        label: "所有合約類型",
      },
      {
        id: 2,
        path: "/services",
        label: "服務介紹",
      },
      {
        id: 3,
        path: "/service-details",
        label: "服務細節",
      }

    ]
  },
  {
    id: 2,
    path: "#",
    label: "頁面",
    dropDown: [
      {
        id: 1,
        path: "/team",
        label: "團隊",
      },
      {
        id: 2,
        path: "/pricing",
        label: "定價方案",
      },
      {
        id: 3,
        path: "/search-result",
        label: "搜尋結果",
      },
      {
        id: 4,
        path: "/testimonials",
        label: "顧客見證",
      },
    ]
  },
  {
    id: 3,
    path: "#",
    label: "法律新知",
    dropDown: [
      {
        id: 1,
        path: "/blog",
        label: "最新文章列表",
      },
      {
        id: 2,
        path: "/blog-details",
        label: "搜尋所有文章",
      }

    ]
  },
  {
    id: 4,
    path: "#",
    label: "關於",
    dropDown: [
      {
        id: 1,
        path: "/about",
        label: "關於 DraftLegal",
      },
      {
        id: 2,
        path: "/faq",
        label: "常見問答",
      },
      {
        id: 3,
        path: "/contact",
        label: "聯絡我們",
      },
      {
        id: 4,
        path: "/privacy-policy",
        label: "隱私政策",
      },
      {
        id: 5,
        path: "/terms-conditions",
        label: "平台使用條款",
      },
    ]
  },
  {
    id: 5,
    path: "#",
    label: "帳號管理",
    dropDown: [
      {
        id: 1,
        path: "/profile",
        label: "用戶資料",
      },
    ]
  },
  
]

